var React = require('react');
var PropTypes = require('prop-types');
var utils = require('styletron-utils');

var isValidAttr = require('./is-valid-attr');

var STYLETRON_KEY = '__STYLETRON';

module.exports = styled;

/**
 * Helper function to create styled element components
 * @packagename styletron-react
 * @param  {String|function} base     Tag name or styled element component
 * @param  {function|object} styleFn  Style object or function that returns a style object
 * @return {function}                 Styled element component
 * @example
 * import {styled} from 'styletron-react';
 *
 * const Panel = styled('div', {
 *   backgroundColor: 'lightblue',
 *   fontSize: '12px'
 * });
 *
 * <Panel>Hello World</Panel>
 * @example
 * import {styled} from 'styletron-react';
 *
 * const Panel = styled('div', (props) => ({
 *   backgroundColor: props.alert ? 'orange' : 'lightblue',
 *   fontSize: '12px'
 * }));
 *
 * <Panel alert>Danger!</Panel>
 * @example
 * import {styled} from 'styletron-react';
 *
 * const DeluxePanel = styled(Panel, (props) => ({
 *   backgroundColor: props.alert ? 'firebrick' : 'rebeccapurple',
 *   color: 'white',
 *   boxShadow: '3px 3px 3px darkgray'
 * }));
 *
 * <DeluxePanel>Bonjour Monde</DeluxePanel>
 */
function styled(base, styleArg) {
  if (typeof base === 'function' && base[STYLETRON_KEY]) {
    var ref = base[STYLETRON_KEY];
    var tag = ref.tag;
    var styles = ref.styles;
    // Styled component
    return createStyledElementComponent(tag, styles.concat(styleArg));
  }
  if (typeof base === 'string' || typeof base === 'function') {
    // Tag name or non-styled component
    return createStyledElementComponent(base, [styleArg]);
  }
  throw new Error('`styled` takes either a DOM element name or a component');
}

function createStyledElementComponent(tagName, stylesArray) {
  var StyledElement = function (props, context) {
    var restProps = assign({}, props);
    delete restProps.innerRef;

    var resolvedStyle = {};
    StyledElement[STYLETRON_KEY].styles.forEach(function (style) {
      if (typeof style === 'function') {
        assign(resolvedStyle, style(restProps, context));
      } else if (typeof style === 'object') {
        assign(resolvedStyle, style);
      }
    });

    var styletronClassName = utils.injectStylePrefixed(
      context.styletron,
      resolvedStyle
    );

    var elementProps = typeof StyledElement[STYLETRON_KEY].tag === 'string'
      ? omitInvalidProps(restProps)
      : restProps;
    elementProps.className = restProps.className
      ? ((restProps.className) + " " + styletronClassName)
      : styletronClassName;

    if (props.innerRef) {
      elementProps.ref = props.innerRef;
    }

    return React.createElement(
      StyledElement[STYLETRON_KEY].tag,
      elementProps
    );
  };
  StyledElement[STYLETRON_KEY] = {
    tag: tagName,
    styles: stylesArray
  };
  StyledElement.contextTypes = {styletron: PropTypes.object};

  return StyledElement;
}

function assign(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }
  return target;
}

function omitInvalidProps(props) {
  var target = {};
  for (var attr in props) {
    if (isValidAttr(attr)) {
      target[attr] = props[attr];
    }
  }
  return target;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/styletron-react/lib/styled.js
// module id = 36
// module chunks = 0